import template from './message.all.html';
import controller from './message.all.controller';
import './message.all.scss';

let messageallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default messageallComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/all/message.all.component.js